import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  AccountIntegrations,
  IntegrationDetails,
  IntegrationID,
  IntegrationsDetails,
} from '../store/interfaces';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(
    private readonly http: HttpClient,
    @Inject('integrationsBaseUrl') private url: string,
  ) {}

  getIntegrations() {
    return of([
      {
        id: 'dynamics',
        author: 'APSIS RnD',
        installations: {
          accounts: 10,
          sections: 30,
        },
      },
      {
        id: 'efficy-enterprise',
        author: 'APSIS RnD',
        installations: {
          accounts: 15,
          sections: 15,
        },
      },
      {
        id: 'lime-crm',
        author: 'APSIS RnD',
        installations: {
          accounts: 1,
          sections: 3000,
        },
      },
    ] as IntegrationsDetails[]);

    return this.http.get<IntegrationsDetails[]>(
      `${this.url}reports/integrations`,
      {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
      },
    );
  }

  getIntegration(id: IntegrationID) {
    return of({
      id,
      author: 'APSIS RnD',
      accounts: [
        {
          accountId: 'pa-josht',
          sections: ['Señor Section', 'Mr Section', 'Herr Section'],
        },
        { accountId: 'kewl-beans', sections: ['My Section'] },
      ],
    } as IntegrationDetails);

    return this.http.get<IntegrationDetails>(
      `${this.url}reports/integrations/${id}`,
      {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
      },
    );
  }

  getAccountIntegrations(accountId: string) {
    return of([
      {
        id: 'dynamics',
        sections: ['Señor Section', 'Mr Section', 'Herr Section'],
      },
      {
        id: 'lime-crm',
        sections: ['Señor Section', 'Mr Section', 'Herr Section'],
      },
    ] as AccountIntegrations[]);

    return this.http.get<AccountIntegrations[]>(
      `${this.url}reports/account/${accountId}`,
      {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
      },
    );
  }
}
